import React from 'react';

export default {
  useBEM: false,
  table: {
    ascButtonContent: (<i className="fas fa-sort-up" />),
    descButtonContent: (<i className="fas fa-sort-down" />),
    noDirectionButtonContent: (<i className="fas fa-sort" />),
    tableClassName: 'table',
  },
  input: {
    inputClassName: 'form-control',
  },
  textarea: {
    inputClassName: 'form-control',
  },
  button: {
    buttonClassName: 'btn',
    sizeLabels: {
      small: 'sm',
      medium: 'md',
      large: 'lg',
    },
  },
  card: {
    className: 'card',
    headerClassName: 'card-header align-center justify-space-between',
    bodyClassName: 'card-body',
  },
};
